import React from 'react';
import ClientPaymentItem from '../../../Domain/ClientPaymentItem';
import ClientPaymentService from '../../../Services/ClientPaymentService';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';

export default class CreateClientPaymentWindowDescription extends React.Component {
  static titleForCreate = 'Add New Client Payment';
  static itemType = ClientPaymentItem;
  static serviceFunction = (edited) => ClientPaymentService.CreateClientPayment(edited, null, false, null);
  static navigateToOnCreation = '/clientpaymentdetails?id=';

  getSelected() {}

  getSearchParameters() {}

  getAllItemInTheSearchAreSelected() {}

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'CpCcid',
          label: 'Client',
          className: 'col-6',
          type: InputTypesEnum.ClientSelect,
          validityChecker: ValidityHelper.forRequiredTextField,
          onFieldChange: CreateClientPaymentWindowDescription.onClientChange,
          showFilterAt: (editItem) => (editItem.staticClient !== 0 ? Number.MAX_SAFE_INTEGER : 10),
        },
        {
          fieldName: 'CpLptid',
          label: 'Payment Type',
          className: 'col-6',
          type: InputTypesEnum.ClientPaymentTypeLookupSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: (item) => CreateClientPaymentWindowDescription.getEntryDate(item),
          label: 'Entry Date',
          className: 'col-6',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'CpDocdate',
          label: 'Payment Instrument Date',
          className: 'col-6',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'CpRcyid',
          label: 'Currency',
          className: 'col-6',
          type: InputTypesEnum.CurrencySelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'CpCheckNumber',
          label: 'Payment Ref #',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: CreateClientPaymentWindowDescription.forCheckNumberField,
        },
        {
          fieldName: 'CpAmountPaid',
          label: 'Amount Paid',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldGreaterThanZero,
        },
        {
          fieldName: 'CpReceivingOfficeId',
          label: 'Receiving Office',
          className: 'col-6',
          type: InputTypesEnum.OfficeSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'CpNotes',
          label: 'Notes',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];

  static getEntryDate(item) {
    item.CpPaymentDate = new Date();
    return item.CpPaymentDate;
  }

  static onClientChange(item) {
    if (item.staticClient !== 0) {
      item.CpCcid = item.staticClient;
    }
    return item.CpCcid;
  }

  static forCheckNumberField(e, item) {
    if (e && e.length > 30) {
      return 'Check Number must be less than or equal to 30 characters';
    }
    return '';
  }
}
